<template>
  <div class="header">
    <div class="logo">
      <img src="@/assets/images/logo.png" alt="logo">
    </div>
    <div class="hd-r">
      <div class="nav">
        <div
            v-for="(item, index) in nav"
            :key="index"
            :class="['item', navIndex === index ? 'active' : '']"
            @click="jumpTo(item)"
        >
          {{ $t('nav.' + item.key) }}
        </div>
      </div>
      <div class="user">
        <div v-if="!isLogin" class="login-btn" @click="openLoginModal">
          <img src="@/assets/images/user.png" alt="登录">
          <span>{{ $t('button.login') }}</span>
        </div>
        <div v-else class="quit" @click="handleLogout">
          {{ $t('button.logout') }}
        </div>

        <LanguageSwitch class="user" />
      </div>



    </div>
  </div>
</template>

<script>
import {removeToken} from "@/utils/auth";
import LanguageSwitch from '@/components/common/LanguageSwitch.vue'

export default {
  components: { LanguageSwitch },

  name: 'PageHeader',
  data() {
    return {
      navIndex: 4,
      nav: [
        { key: 'home', path: '/index' },
        { key: 'contact', path: '/contact' },
        { key: 'about', path: '/about' },
        { key: 'join', path: '/join' },
        { key: 'dataService', path: '/home' }
      ],
      isLogin: false // 登录状态变量
    };
  },
  mounted() {
    this.updateNavIndex();

    if (!this.$i18n) {
      console.error('当前组件上下文缺失i18n实例')
    }

    // 初始化登录状态
    this.isLogin = localStorage.getItem('isLogin') === 'true';

    // 检查事件总线是否存在
    if (!this.$bus) {
      console.error('事件总线未注册，请在main.js中添加: Vue.prototype.$bus = new Vue()');
      return;
    }

    // 监听登录状态变化事件
    this.$bus.$on('login-status-changed', (isLogin) => {
      console.log('导航栏监听到登录状态变化:', isLogin);
      this.isLogin = isLogin;
      this.$forceUpdate(); // 强制更新视图
    });
  },
  beforeDestroy() {
    // 移除事件监听，避免内存泄漏
    this.$bus && this.$bus.$off('login-status-changed');
  },
  methods: {
    jumpTo(item) {
      this.isLogin = localStorage.getItem('isLogin') === 'true'; //检查是否登陆
      if (item.path === '/home') {
         if (!this.isLogin) {
            this.openLoginModal(); //打开登陆窗口
            return;
         }
      }
      console.log("[DEBUG] jumpTo(item):", item);
      this.$router.push(item.path);
    },
    updateNavIndex() {
      this.navIndex = this.nav.findIndex(item => item.path === this.$route.path);
    },
    openLoginModal() {
      // 触发登录弹窗事件，替代路由跳转
      console.log('openLoginModal IN');
      this.$bus.$emit('show-login-dialog');
    },
    handleLogout() {
      // 清除登录状态
      localStorage.removeItem('isLogin'); //删除登陆状态
      removeToken(); //删除token
      this.isLogin = false;
      // 通知其他组件登录状态变化
      this.$bus && this.$bus.$emit('login-status-changed', false);
    }
  },
  watch: {
    '$route.path': function() {
      this.updateNavIndex();
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 30px;
  background: #10AAC2;
  height: 64px;
}
.logo {
  display: block;
  height: 36px;
}
.logo img {
  display: block;
  height: 100%;
}
.hd-r {
  flex: 0 0 calc(100% - 260px);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav {
  display: flex;
}
.nav .item {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 100px;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  transition: background 0.3s ease;
}
.nav .item.active {
  background: #0F8C9F;
}
.nav .item:hover:not(.active) {
  background: rgba(255, 255, 255, 0.1);
}
.user {
  display: flex;
  align-items: center;
}
.login-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 10px;
  height: 40px;
  border-radius: 4px;
  transition: background 0.2s;
}
.login-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
.login-btn img {
  display: block;
  width: 24px;
  margin-right: 3px;
  height: 24px;
}
.login-btn span {
  font-size: 16px;
  color: #FFFFFF;
}
.quit {
  cursor: pointer;
  width: 66px;
  height: 24px;
  background: rgba(255,255,255,0);
  border-radius: 2px;
  border: 1px solid #EFEFEF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #FFFFFF;
  transition: all 0.2s;
}
.quit:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>